import * as Sentry from '@sentry/react';

/**
 * Initialise Sentry côté client si un DSN est fourni (VITE_SENTRY_DSN).
 * No-op silencieux sinon : l'app tourne normalement sans Sentry configuré.
 *
 * Vars d'env (Vite, préfixe VITE_) :
 *  - VITE_SENTRY_DSN      : DSN public du projet Sentry (obligatoire pour activer)
 *  - VITE_SENTRY_RELEASE  : identifiant de release (optionnel, ex. hash git / version)
 *  - VITE_SENTRY_DEV=1    : autorise l'envoi d'événements depuis le dev local (défaut: off)
 */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE || undefined,
    integrations: [Sentry.browserTracingIntegration()],
    // Échantillonnage tracing : 10% en prod, tout en dev.
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
    // Vie privée invité : pas d'IP / données perso par défaut.
    sendDefaultPii: false,
    // N'envoie pas depuis le dev local sauf activation explicite.
    enabled: import.meta.env.PROD || import.meta.env.VITE_SENTRY_DEV === '1',
  });
}

export { Sentry };
